import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './ProductCard.css';

const ProductCard = ({ product }) => {
  const [imageError, setImageError] = useState(false);
  
  // Obtener URL de la imagen (portada o primera extra)
  const getImageUrl = () => {
    if (imageError) return '/images/default-product.jpg';
    
    if (product.imagen_portada) {
      return product.imagen_portada.startsWith('http') 
        ? product.imagen_portada 
        : `https://api.romanvalderrabanoelcatador.com/api/uploads/productos/${product.imagen_portada}`;
    }
    
    if (product.imagenes_extra && product.imagenes_extra.length > 0) {
      return `https://api.romanvalderrabanoelcatador.com/api/uploads/productos/${product.imagenes_extra[0]}`;
    }
    
    return '/images/default-product.jpg';
  };

  // Formatear precio
  const formatPrice = (price) => {
    const numPrice = typeof price === 'number' ? price : parseFloat(price) || 0;
    return numPrice.toFixed(2);
  };

  return (
    <Link to={`/product/${product.id}`} className="product-card">
      <div className="product-image-container">
        <img 
          src={getImageUrl()} 
          alt={product.nombre}
          className="product-image"
          onError={() => setImageError(true)}
        />
        {product.destacado && (
          <span className="product-badge">⭐ Destacado</span>
        )}
        {product.imagenes_extra && product.imagenes_extra.length > 0 && (
          <span className="image-count-badge">
            📸 {product.imagenes_extra.length + (product.imagen_portada ? 1 : 0)}
          </span>
        )}
      </div>
      
      <div className="product-info">
        <h3 className="product-title">{product.nombre}</h3>
        <p className="product-category">{product.categoria}</p>
        
        <div className="product-price-section">
          <span className="product-price">${formatPrice(product.precio)} MXN</span>
          {product.presentaciones && product.presentaciones.length > 0 && (
            <span className="product-variants">
              +{product.presentaciones.length} presentaciones
            </span>
          )}
        </div>
        
        <div className="product-stock">
          {product.stock > 0 ? (
            <span className="in-stock">✅ Disponible</span>
          ) : (
            <span className="out-of-stock">❌ Agotado</span>
          )}
        </div>
      </div>
    </Link>
  );
};

export default ProductCard;